import { useNavigate } from 'react-router-dom';
import { lsSet } from '../lib/storage';

const CG  = { fontFamily: "'Cormorant Garamond', serif" };
const CZ  = { fontFamily: "'Cinzel', serif" };

const STORAGE_KEY = 'diwanWelcomeV1Seen';

// eslint-disable-next-line react-refresh/only-export-components
export function shouldShowWelcome() {
  try { return !localStorage.getItem(STORAGE_KEY); } catch { return false; }
}

export default function WelcomeSheet({ onClose }) {
  const navigate = useNavigate();

  function dismiss() {
    lsSet(STORAGE_KEY, '1');
    onClose();
  }

  function goTab(tab) {
    lsSet(STORAGE_KEY, '1');
    onClose();
    navigate(`/premium`, { state: { tab } });
  }

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={dismiss}
        style={{
          position: 'fixed', inset: 0, zIndex: 9300,
          background: 'rgba(0,0,0,0.55)',
        }}
      />

      {/* Sheet */}
      <div style={{
        position: 'fixed', bottom: 0, left: '50%', transform: 'translateX(-50%)',
        width: '100%', maxWidth: 480,
        zIndex: 9301,
        background: 'var(--bg)',
        borderRadius: '20px 20px 0 0',
        borderTop: '1px solid var(--border2)',
        padding: '0 0 env(safe-area-inset-bottom)',
        animation: 'slideUp 0.32s cubic-bezier(0.32,0.72,0,1)',
      }}>
        {/* Handle */}
        <div style={{ display: 'flex', justifyContent: 'center', padding: '12px 0 0' }}>
          <div style={{ width: 36, height: 4, borderRadius: 2, background: 'var(--border)' }} />
        </div>

        <div style={{ padding: '18px 22px 24px' }}>

          {/* Founder row */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
            <div style={{
              width: 40, height: 40, borderRadius: '50%', flexShrink: 0,
              background: 'rgba(229,150,83,0.15)',
              border: '1.5px solid rgba(229,150,83,0.35)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              ...CZ, fontSize: 14, color: 'var(--gold)', fontWeight: 700,
            }}>S</div>
            <div>
              <div style={{ ...CZ, fontSize: 8, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 2 }}>
                Welcome — From the Founder
              </div>
              <div style={{ ...CG, fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>Samiul Islam</div>
            </div>
          </div>

          {/* Quote */}
          <p style={{ ...CG, fontSize: 15, fontStyle: 'italic', color: 'var(--text2)', lineHeight: 1.65, margin: '0 0 8px' }}>
            "I couldn't find a tool that brought everything together for studying classical Arabic poetry — so I built the one I always wished existed."
          </p>
          <p style={{ ...CG, fontSize: 13, color: 'var(--text3)', lineHeight: 1.6, margin: '0 0 20px' }}>
            Al-Diwan is a community project — no ads, no investors. Everything in the library is free. AI analysis is funded by the community and cached permanently for all future readers.
          </p>

          {/* Action buttons */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <button
              onClick={() => goTab('why')}
              style={{
                width: '100%', padding: '13px 16px',
                background: 'var(--bg2)', border: '1px solid var(--gold-line)',
                borderRadius: 10, cursor: 'pointer', textAlign: 'left',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}
            >
              <div>
                <div style={{ ...CZ, fontSize: 8, letterSpacing: 1.5, textTransform: 'uppercase', color: 'var(--gold)', marginBottom: 3 }}>Our Story</div>
                <div style={{ ...CG, fontSize: 12.5, color: 'var(--text2)' }}>About Me, why this exists, the sadaqah jāriyah model</div>
              </div>
              <span style={{ color: 'var(--gold)', fontSize: 16, flexShrink: 0, marginLeft: 10 }}>›</span>
            </button>

            <button
              onClick={() => goTab('included')}
              style={{
                width: '100%', padding: '13px 16px',
                background: 'var(--bg2)', border: '1px solid var(--border2)',
                borderRadius: 10, cursor: 'pointer', textAlign: 'left',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              }}
            >
              <div>
                <div style={{ ...CZ, fontSize: 8, letterSpacing: 1.5, textTransform: 'uppercase', color: 'var(--text3)', marginBottom: 3 }}>What's Included</div>
                <div style={{ ...CG, fontSize: 12.5, color: 'var(--text2)' }}>Library, AI analysis, flashcards, learning tracks & more</div>
              </div>
              <span style={{ color: 'var(--text3)', fontSize: 16, flexShrink: 0, marginLeft: 10 }}>›</span>
            </button>

            <button
              onClick={dismiss}
              style={{
                width: '100%', padding: '13px',
                background: 'var(--gold)', border: 'none',
                borderRadius: 10, cursor: 'pointer',
                ...CZ, fontSize: 9, letterSpacing: 2, textTransform: 'uppercase',
                color: '#1a1409', fontWeight: 600,
              }}
            >
              Start reading →
            </button>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from { transform: translateX(-50%) translateY(100%); }
          to   { transform: translateX(-50%) translateY(0); }
        }
      `}</style>
    </>
  );
}
